import { fetchEventSource, type FetchEventSourceInit } from '@microsoft/fetch-event-source';
import type { Method } from 'axios';

import { isNative } from '@whelk/const/src/env';
import { LocalStorageTokenKey } from '@whelk/const/src/token';

import { publicEncrypt } from './encrypt';
import {
  addFetchUrlPublicParams,
  getNativeNetworkParams,
  getNativePublicHeader,
  handleGeneralParams,
} from './publicParams';

export const addSseUrlPublicParams = (url: string, time: number) => {
  let params;
  if (isNative) {
    params = getNativeNetworkParams(time);
  } else {
    params = handleGeneralParams(time);
  }
  return addFetchUrlPublicParams(url, params);
};

// fetch 请求拦截器 用于 sse 接口
export const sseFetchIntercept = (url: string, body: any, fetchParams: FetchEventSourceInit) => {
  const time = Date.parse(new Date().toString());
  const addFetchParamsUrl = addSseUrlPublicParams(url, time);

  const yy = publicEncrypt({
    hasSearchParamsPath: addFetchParamsUrl,
    method: fetchParams?.method as Method,
    time: time,
    body: body,
  });

  let headers = {};

  if (isNative) {
    headers = { ...getNativePublicHeader() };
  }

  Object.assign(headers, {
    yy: (yy as any) ?? '',
    'Content-type': 'application/json',
    token: window.localStorage.getItem(LocalStorageTokenKey) ?? '',
    ...(fetchParams?.headers ?? {}),
  });

  return fetchEventSource(addFetchParamsUrl, {
    method: fetchParams.method,
    headers,
    body: JSON.stringify(body),
    ...fetchParams,
  });
};
